import React, { forwardRef } from 'react';
import clsx from 'clsx';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/core/Icon/';
import { Card, CardContent, Grid, Typography, Avatar, MenuList } from '@material-ui/core';
import { render } from 'react-dom';
import { Dropdown, DropdownButton, SplitButton, ButtonGroup } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import axios from './axios';

// import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
	root: {},
	formControl: {
		minWidth: 120,
	},
	selectEmpty: {},
	title: {
		fontSize: '3rem',
		color: '#101820FF',
		lineHeight: '50px',
		'@media (max-width:787px)': {
			fontSize: '1.3rem',
		},
	},
	SubHeadingWrapper: {
		marginTop: '5vh',
		'@media (max-width:787px)': {
			marginTop: '1vh',
		},
	},
	subTitle: {
		fontSize: '30px',
		color: '#101820FF',
		'@media (max-width:787px)': {
			fontSize: '18px',
		},
	},

	FooterTitle: {
		lineHeight: '130px',
		fontSize: '35px',
		color: '#101820FF',
	},
	resize: {
		color: 'white',
	},
	inputColor: {
		color: 'white',
		fontWeight: 'bold',
	},
	movingFont: {
		fontSize: '20px',
	},
	Button: {
		width: 250,
		marginTop: '0.7vh',
		height: '7vh',
		fontSize: '20px',
		color: 'white',
		borderRadius: '25px',
		background: '#101820FF',
		'&:hover': {
			backgroundColor: '#101820FF',
			color: 'white',
		},
	},
	DialogSubText: {
		color: '#7f7979',
		fontWeight: 'bold',
		lineHeight: '4vh',
		padding: '0 2vh',
	},

	DialogTitleHeading: {
		fontSize: '40px',
		'@media (max-width:787px)': {
			fontSize: '22px',
			lineHeight: '22px',
		},
	},
	DialogSubTitle: {
		fontSize: '30px',
		'@media (max-width:787px)': {
			fontSize: '18px',
			lineHeight: '18px',
		},
	},
	Autocomplete: {
		backgroundColor: 'white',

		color: 'white',
	},
	label: {
		'&$focusedLabel': {
			color: 'cyan',
		},
		'&$erroredLabel': {
			color: 'orange',
		},
	},
	focusedLabel: {},
	erroredLabel: {},
	underline: {
		'&$error:after': {
			borderBottomColor: 'orange',
		},
		'&:after': {
			borderBottom: `2px solid cyan`,
		},
	},
	PD: {
		'@media (max-width:780px)': {
			padding: '0',
		},
	},
	MT: {
		marginTop: '8vh',
		'@media (max-width:780px)': {
			marginTop: '0vh',
		},
	},
	btnWrapperstyle: {
		paddingLeft: '7vh',
		display: 'flex',
		alignItems: 'center',
		'@media (max-width:1280px)': {
			padding: '0',
		},
	},
	closeButton: {
		position: 'absolute',
		padding: '0',
		left: '90%',
		top: '8%',
	},
	Cross: {
		textTransform: 'lowercase',
		fontSize: '18px',
		color: 'red',
		padding: '0 20px',
	},

	DropDownList: {
		position: 'relative',
		width: '100%',
	},
	DialogContent: {
		'@media (max-width:787px)': {
			padding: '8px 16px',
		},
	},
	FormContainer: {
		marginTop: '5vh',
		'@media (max-width:787px)': {
			marginTop: '2vh',
		},
	},
});

const DialogTitle = withStyles(styles)(props => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant='h6'>{children}</Typography>
			{onClose ? (
				<IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

class MoreInfoPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			livingRoom: '',
			diningRoom: '',
			bedRoom: '',
			misc: '',
			kitchen: '',
			Nursery: '',
			Cartons: '',
			Appliances: '',
			Porch: '',

			specificationMessagae: '',

			title: 'TV',
			/*==========BEDROOMS===================================== */
			OpenArmoire: false,
			nameArmoire: '',

			OpenBed: false,
			nameBed: '',

			OpenChair: false,
			nameChair: '',

			OpenStraight: false,
			nameStraight: '',

			OpenChaiseLounge: false,
			nameChaiseLounge: '',

			OpenChestOfDrawers: false,
			nameChestOfDrawers: '',

			OpenDresser: false,
			nameNightTable: '',

			OpenRug: false,
			nameRug: '',

			OpenVanity: false,
			nameVanity: '',

			/*==========DINING ROOM===================================== */
			OpenDiningChair: false,
			nameDiningChair: '',

			OpenBuffet: false,
			nameBuffet: '',

			OpenHutch: false,
			nameHutch: '',

			OpenServer: false,
			nameServer: '',

			OpenTable: false,
			nameTable: '',

			OpenTeaCart: false,
			nameHutch: '',

			OpenRug: false,
			nameRug: '',
			/*======MISCELLANEOUS===================== */
			OpenBicycle: false,
			nameBicycle: '',

			OpenBirdCage: false,
			nameBirdCage: '',

			OpenCabinetFiling: false,
			nameCabinetFiling: '',

			OpenClothesHamper: false,
			nameClothersHamper: '',

			OpenComputer: false,
			nameComputer: '',

			OpenFan: false,
			nameFan: '',

			OpenFoldingChair: false,
			nameFoldingChair: '',

			OpenFootLocker: false,
			nameFootLocker: '',

			OpenGarbageCan: false,
			nameGarbageCan: '',

			OpenGolfBag: false,
			nameGolfBag: '',

			OpenHeater: false,
			nameHeater: '',

			OpenOfficeChair: false,
			nameOfficeChair: '',

			OpenPingPongTable: false,
			namePingPongTable: '',

			OpenRollawayCot: false,
			nameRollawayCot: '',

			OpenSkis: false,
			nameSkis: '',

			OpenStepLadder: false,
			nameStepLadder: '',

			OpenSuitcase: false,
			nameSuitcase: '',

			OpenTire: false,
			nameTire: '',

			OpenToolChest: false,
			nameToolChest: '',

			OpenTrunk: false,
			nameTrunk: '',

			OpenWagon: false,
			nameWagon: '',

			OpenWaterCooler: false,
			nameWaterCooler: '',

			OpenWeights: false,
			nameWeights: '',

			OpenWeightBench: false,
			nameWeightBench: '',

			OpenWheelBarrow: false,
			nameWheelBarrow: '',

			OpenWorkBench: false,
			nameWorkBench: '',
			/* ============LIVING ROOM===================== */
			OpenBench: false,
			nameBench: '',
			shareholders: [{ name: '' }],

			OpenBookCase: false,
			nameBookCase: '',

			OpenBookShelves: false,
			nameBookShelves: '',

			OpenChair: false,
			nameChair: '',

			OpenDesk: false,
			nameDesk: '',

			OpenFireplaceTools: false,
			nameFireplaceTools: '',

			OpenFootStool: false,
			nameFootStool: '',

			OpenFuton: false,
			nameFuton: '',

			OpenLamp: false,
			nameLamp: '',

			OpenMusic: false,
			nameMusic: '',

			OpenPiano: false,
			namePiano: '',

			OpenRug: false,
			nameRug: '',

			OpenStereo: false,
			nameStereo: '',

			OpenTable: false,
			nameTable: '',

			OpenTelephoneStand: false,
			nameTelephoneStand: '',

			OpenTV: false,
			nameTV: '',

			OpenTvStand: false,
			nameTvStand: '',

			/*========KITCHEN================ */
			OpenBreakfastChair: false,
			nameBreakfastChair: '',

			OpenBreakfastTable: false,
			nameBreakfastTable: '',

			OpenIroningBoard: false,
			nameIroningBoard: '',

			OpenKitchenCabinet: false,
			nameKitchenCabinet: '',

			OpenMicrowaveStand: false,
			nameMicrowaveStand: '',

			OpenStool: false,
			nameStool: '',

			OpenUtilityCabinet: false,
			nameUtilityCabinet: '',

			OpenUtilityTable: false,
			nameUtilityTable: '',

			/*===========CARTONS=================== */
			OpenBox: false,
			nameBox: '',

			OpenChinaBarrel: false,
			nameChinaBarrel: '',

			OpenLampShade: false,
			nameLampShade: '',

			OpenMirror: false,
			nameMirror: '',

			OpenWardrobe: false,
			nameWardrobe: '',
			/*===========NURSERY=================== */
			OpenBassinet: false,
			nameBassinet: '',

			OpenBed: false,
			nameBed: '',

			OpenChair: false,
			nameChair: '',

			OpenChest: false,
			nameChest: '',

			OpenCrib: false,
			nameCrib: '',

			OpenPlayPen: false,
			namePlayPen: '',

			OpenRug: false,
			nameRug: '',

			OpenStroller: false,
			nameStroller: '',

			/*===========APPLIANCES================ */
			OpenAirConditioner: false,
			nameAirConditioner: '',

			OpenDehumdifier: false,
			nameDehumdifier: '',

			OpenDishwasher: false,
			nameDishwasher: '',

			OpenDryer: false,
			nameDryer: '',

			OpenFreezer: false,
			nameFreezer: '',

			OpenMicrowave: false,
			nameMicrowave: '',

			OpenRange: false,
			nameRange: '',

			OpenRefrigerator: false,
			nameRefrigerator: '',

			OpenSewingMachine: false,
			nameSewingMachine: '',

			OpenVaccumCleaner: false,
			nameVacuumCleaner: '',

			OpenWashingMachine: false,
			nameWashingMachine: '',
			/*===========PORCH===================== */
			OpenTools: false,
			nameTools: '',

			OpenLadder: false,
			nameLadder: '',

			OpenLawnChair: false,
			nameLawnChair: '',

			OpenLawnMover: false,
			nameLawnMover: '',

			OpenOutdoorChildSlide: false,
			nameOutdoorChildSlide: '',

			OpenOutdoorDryingRack: false,
			nameOutdoorDryingRack: '',

			OpenOutdoorSwingSet: false,
			nameOutdoorSwingSet: '',

			OpenPicnicBench: false,
			namePicnicBench: '',

			OpenPicnicTable: false,
			namePicnicTable: '',

			OpenOutdoorPortableBBQ: false,
			nameOutdoorPortableBBQ: '',

			OpenOutdoorPorchChair: false,
			nameOutdoorPorchChair: '',

			OpenRockerSwing: false,
			nameRockerSwing: '',

			OpenSandbox: false,
			nameSandbox: '',

			OpenSettee: false,
			nameSettee: '',

			OpenUmbrella: false,
			nameUmbrella: '',

			/*==========CARTONSFORANAVERAGE */
			openModel: false,
			openModelDining: false,
			openModelBedroom: false,
			openModelKitchen: false,
			openModelMiscellaneous: false,
			openModelNursery: false,
			openModelPorch: false,
			openModelCarton: false,
			openModelAppliances : false,
			selectedCategory: 'Living_Room',
			Bed_Rooms: {
				categoryId: '',
				items: [
					{ isSelected: false, item: 'Armoire', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Bed', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Chair', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Straight', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Chaise_Lounge', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Chest_Of_Drawers', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Dresser', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Rug', itemId: '', quantity: '' },
					{ isSelected: false, item: 'Vanity', itemId: '', quantity: '' },
				],
			},
			Dining_Room: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Dining_Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Buffet', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Hutch', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Server', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Table', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Tea_Cart', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Rug', quantity: '' },
				],
			},
			Miscellaneous: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Bicycle', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Bird_Cage', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Cabinet_Filing', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Computer', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Fan', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Folding_Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Foot_Locker', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Garbage_Can', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Golf_Bag', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Heater', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Office_Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Ping_Pong_Tables', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Rollaway_Cot', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Skis', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Step_Ladder', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Tool', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Suitcase', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Tool_Chest', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Trunk', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Wagon', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Water_Cooler', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Weights', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Weight_Bench', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Wheel_Barrow', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Work_Bench', quantity: '' },
				],
			},
			Living_Room: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Bench', quantity: '' },
					{ isSelected: false, itemId: '', item: 'BookCase', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Book_Shelves', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Desk', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Fireplace_Tools', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Foot_Stool', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Futon', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Lamp', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Music', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Piano', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Rug', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Stereo', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Table', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Telephone_Stand', quantity: '' },
					{ isSelected: false, itemId: '', item: 'TV', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Tv_Stand', quantity: '' },
				],
			},
			Kitchen: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Breakfast_Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Breakfast_Table', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Ironing_Board', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Kitchen_Cabinet', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Microwave_Stand', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Stool', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Dishwashers', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Utility_Cabinet', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Utility_Table', quantity: '' },
				],
			},
			Cartons: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Box', quantity: '' },
					{ isSelected: false, itemId: '', item: 'China_Barrel', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Lamp_Shade', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Mirror', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Microwave_Stand', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Wardrobe', quantity: '' },
				],
			},
			Nursery: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Bassinet', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Bed', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Chest', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Crib', quantity: '' },
					{ isSelected: false, itemId: '', item: 'PlayPen', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Rug', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Stroller', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Utility_Table', quantity: '' },
				],
			},
			Appliances: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Air_Conditioner', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Dehumdifier', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Dishwasher', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Dryer', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Freezer', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Microwave', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Foot_Stool', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Range', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Refrigerator', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Sewing_Machine', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Vaccum_Cleaner', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Washing_Machine', quantity: '' },
				],
			},
			Porch: {
				categoryId: '',
				items: [
					{ isSelected: false, itemId: '', item: 'Tools', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Ladder', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Lawn_Chair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Lawn_Mover', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Outdoor_Childslide', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Outdoor_Dryingrack', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Outdoor_Swingset', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Picnic_Bench', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Picnic_Table', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Outdoor_PortableBBQ', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Outdoor_Porchchair', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Rocker_Swing', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Sandbox', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Settee', quantity: '' },
					{ isSelected: false, itemId: '', item: 'Umbrella', quantity: '' },
				],
			},

			Quantity: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }],
			selectedQuantity: 0,
			Sizes: {
				/*BedRoom */
				Bed: ['Single', 'Double', 'Bunk (Set of 2)', 'Queen Size', 'King Size'],
				Chest_Of_Drawers: ['SM,LG'],
				Dresser: ['Single', 'Double', 'Triple'],
				Buffet: ['Base'],
				Hutch: ['Top'],
				Cabinet_Filing: ['2 Drawer', '4 Drawer'],
				/*LIVINGROOM */
				Bench: ['Piano'],
				Chair: ['Arm', 'Ocassional', 'Oversized', 'Recliner', 'Rocking', 'Straight'],
				Sofa: ['Loveseat', '3 Cushions', 'Hide A Bed'],
				Piano: ['APT', 'Baby GR', 'Upright', 'Parlour GR'],
				Rug: ['Small', 'Large'],
				Stereo: ['Speaker', 'Coffee', 'End'],
				TV: ['CRT Tube', '19*', '32*', 'Flat Screen 50*', 'Flat Screen 60*'],
				/*KITCHEN */
				/*CARTONS */
				Box: ['2 CU.FT', '4 CU.FT', '5 CU.FT', '6 CU.FT'],
				Mirror: ['Small', 'Large'],
				/*NURSERY */
				Crib: ['Baby'],
				Table: ['Child'],
				/*APPLIANCES */
				Freezer: ['10 CU.FT or Less', '11-15 CU.FT', '16 CU.FT or Over'],
				Refrigerator: ['6 CU.FT', '7-10 CU.FT', '11 Cu.FT & Over'],
				Sewing_Machine: ['Cabinet', 'Portable', 'Serger'],
				/*PORCH */
				Ladder: ['Extension'],
				Lawn_Chair: ['Stacking,Hand,Power'],
			},

			details: {
				/*DINING */
				Dining_Room: {
					Dining_Chair: [],
					Buffet: [],
					Hutch: [],
					Server: [],
					Table: [],
					Tea_Cart: [],
					Rug: [],
				},

				/*BEDROOM */
				Bed_Rooms: {
					Armoire: [],
					Bed: [],
					TV: [],
					Chair: [],
					Straight: [],
					Chaise_Lounge: [],
					Chest_Of_Drawers: [],
					Dresser: [],
					Rug: [],
					Vanity: [],
				},
				/*MISCELLANEOUS */
				Miscellaneous: {
					Bicycle: [],
					Bird_Cage: [],
					Cabinet_Filing: [],
					Clothes_Hamper: [],
					Computer: [],
					Fan: [],
					Folding_Chair: [],
					Foot_Locker: [],
					Garbage_Can: [],
					Boxes: [],
					Golf_Bag: [],
					Heater: [],
					Office_Chair: [],
					Ping_Pong_Table: [],
					Rollaway_Cot: [],
					Skis: [],
					Step_Ladder: [],
					Suitcase: [],
					Tire: [],
					Tool_Chest: [],
					Trunk: [],
					Wagon: [],
					Weights: [],
					Weight_Bench: [],
					Wheel_Barrow: [],
					Work_Bench: [],
				},
				/*LIVINGROOM */
				Living_Room: {
					Bench: [],
					BookCase: [],
					Book_Shelves: [],
					Chair: [],
					Desk: [],
					Fireplace_Tools: [],
					Foot_Stool: [],
					Futon: [],
					Lamp: [],
					Music: [],
					Piano: [],
					Rug: [],
					Stereo: [],
					Table: [],
					Telephone_Stand: [],
					TV: [],
					Tv_Stand: [],
				},

				/*KITCHEN */
				Kitchen: {
					Breakfast_Chair: [],
					Breakfast_Table: [],
					Ironing_Board: [],
					Kitchen_Cabinet: [],
					Microwave_Stand: [],
					Stool: [],
					Utility_Cabinet: [],
					Utility_Table: [],
				},
				/* CARTONS */
				Cartons: {
					Box: [],
					China_Barrel: [],
					Lamp_Shade: [],
					Mirror: [],
					Microwave_Stand:[],
					Wardrobe: [],
				},
				/*NURSERY */
				Nursery: {
					Bassinet: [],
					Bed: [],
					Chair: [],
					Chest: [],
					Crib: [],
					PlayPen: [],
					Rug: [],
					Stroller: [],
					Utility_Table: [],
				},
				/*APPLIANCES */
				Appliances: {
					Air_Conditioner: [],
					Dehumdifier: [],
					Dishwasher: [],
					Dryer: [],
					Freezer: [],
					Microwave: [],
					Foot_Stool: [],
					Range: [],
					Refrigerator: [],
					Sewing_Machine: [],
					Vaccum_Cleaner: [],
					Washing_Machine: [],
				},
				/*PORCH */
				Porch: {
					Tools: [],
					Ladder: [],
					Lawn_Chair: [],
					Lawn_Mover: [],
					Outdoor_Childslide: [],
					Outdoor_Dryingrack: [],
					Outdoor_Swingset: [],
					Picnic_Bench: [],
					Picnic_Table: [],
					Outdoor_PortableBBQ: [],
					Outdoor_Porchchair: [],
					Rocker_Swing: [],
					Sandbox: [],
					Settee: [],
					Umbrella: [],
				},
			},
		};
	}

	handleOpen = (item, sm, category) => {
		this.setState({ openModel: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleClose = () => {
		this.setState({ openModel: !this.state.openModel });
	};

	handleOpenDining = (item, sm, category) => {
		this.setState({ openModelDining: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseDining = () => {
		this.setState({ openModelDining: !this.state.openModelDining });
	};


	handleOpenBedroom = (item, sm, category) => {
		this.setState({ openModelBedroom: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseBedroom = () => {
		this.setState({ openModelBedroom: !this.state.openModelBedroom });
	};

	handleOpenMiscellaneous = (item, sm, category) => {
		this.setState({ openModelMiscellaneous: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseMiscellaneous = () => {
		this.setState({
			openModelMiscellaneous: !this.state.openModelMiscellaneous,
		});
	};
	handleOpenKitchen = (item, sm, category) => {
		this.setState({ openModelKitchen: true, title: item, specificationMessagae: sm, selectedCategory: category });
		console.log(this.openModelKitchen)
	};
	handleCloseKitchen = () => {
		this.setState({
			openModelKitchen: !this.state.openModelKitchen,
		});
	};
	handleOpenNursery = (item, sm, category) => {
		this.setState({ openModelNursery: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseNursery = () => {
		this.setState({
			openModelNursery: !this.state.openModelNursery,
		});
	};

	handleOpenCarton = (item, sm, category) => {
		this.setState({ openModelCarton: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseCarton = () => {
		this.setState({
			openModelCarton: !this.state.openModelCarton,
		});
	};
	handleOpenPorch = (item, sm, category) => {
		this.setState({ openModelPorch: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleClosePorch = () => {
		this.setState({
			openModelPorch: !this.state.openModelPorch,
		});
	};

	handleOpenCarton = (item, sm, category) => {
		this.setState({ openModelCarton: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseCarton = () => {
		this.setState({
			openModelCarton: !this.state.openModelCarton,
		});
	};

	handleOpenAppliance = (item, sm, category) => {
		this.setState({ openModelAppliances: true, title: item, specificationMessagae: sm, selectedCategory: category });
	};
	handleCloseAppliance = () => {
		this.setState({
			openModelAppliances: !this.state.openModelAppliances,
		});
	};

	handleShareholderName = idx => evt => {
		const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
			if (idx !== sidx) return shareholder;
			return { ...shareholder, nameBench: evt.target.value };
		});
		this.setState({ shareholders: newShareholders });
	};
	handleChangeSelect = (title, newQuantity) => {
		this.setState({ selectedQuantity: newQuantity });
		let newArray = [];
		if (title === 'Gym_Equipment' && typeof newQuantity === 'string') {
			newArray.push({ id: 0, sizing: newQuantity });
			if (this.search(this.state.Miscellaneous).find) {
				this.setState(prevState => {
					let updatedDetails = [...prevState.Miscellaneous.items];
					updatedDetails[this.search(this.state.Miscellaneous.items).index] = { isSelected: true, item: title };
					return {
						...prevState.Miscellaneous,
						Miscellaneous: { ...prevState.Miscellaneous, items: updatedDetails },
					};
				});
			}
		} else {
			for (let i = 0; i < newQuantity; i++) {
				newArray.push({ id: i, sizing: 0 });
			}
		}
		console.log(newArray);
		this.setState(prevState => {
			console.log({ ...prevState.details, [prevState.selectedCategory]: { ...prevState.details[this.state.selectedCategory], [this.state.title]: newArray } });
			return {
				...prevState,
				details: { ...prevState.details, [prevState.selectedCategory]: { ...prevState.details[this.state.selectedCategory], [this.state.title]: newArray } },
			};
		});
	};
	handleSubmit = async evt => {
		evt.preventDefault();

		try {
			let categoryId = this.state[this.state.selectedCategory].categoryId;
			if (categoryId !== '') {
				this.state.details[this.state.selectedCategory][this.state.title].forEach(async detailItem => {
					let itemDetails = {
						name: this.state.title,
						size: detailItem.sizing,
						categoryId,
					};
					let item = await axios.post('/items', itemDetails);

					if (item.status === 201) {
						this.setState(prevState => {
							let updatedItems = prevState[this.state.selectedCategory].items;
							updatedItems.map(items => {
								if (items.item === this.state.title) {
									return (items.itemId = item.data.item._id);
								}
							});
							// console.log(updatedItems);
							// console.log(this.state[this.state.selectedCategory]);
							return {
								[this.state.selectedCategory]: { ...prevState[this.state.selectedCategory], items: updatedItems },
							};
						});
					}
				});
			} else {
				const category = await axios.post('/categories', { name: this.state.selectedCategory.replace(/_/g, ' ') });
				if (category.status === 201) {
					let categoryId = category.data.Client._id;
					this.setState(prevState => {
						return {
							[this.state.selectedCategory]: { ...prevState[this.state.selectedCategory], categoryId: categoryId },
						};
					});
					this.state.details[this.state.selectedCategory][this.state.title].forEach(async detailItem => {
						let itemDetails = {
							name: this.state.title,
							size: detailItem.sizing,
							categoryId,
						};
						let item = await axios.post('/items', itemDetails);

						if (item.status === 201) {
							this.setState(prevState => {
								let updatedItems = prevState[this.state.selectedCategory].items;
								updatedItems.map(items => {
									if (items.item === this.state.title) {
										return (items.itemId = item.data.item._id);
									}
								});
								// console.log(updatedItems);
								// console.log(this.state[this.state.selectedCategory]);
								return {
									[this.state.selectedCategory]: { ...prevState[this.state.selectedCategory], items: updatedItems },
								};
							});
						}
					});
				}
			}
		} catch (err) {
			console.log(err);
		}

		this.setState({ openModel: false, openModelDining: false, openModelBedroom: false, openModelKitchen: false, openModelMiscellaneous: false , openModelNursery : false, openModelCarton : false, openModelPorch:false, openModelAppliances : false });
		const { nameBench, shareholders } = this.state;
	};

	bedRoomChangeHandler = e => {
		this.setState({
			bedRoom: e.target.value,
		});
	};

	diningRoomChangeHandler = e => {
		this.setState({
			diningRoom: e.target.value,
		});
	};

	livingRoomChangeHandler = e => {
		this.setState({
			livingRoom: e.target.value,
		});
	};

	miscChangeHandler = e => {
		this.setState({
			misc: e.target.value,
		});
	};

	kitchenChangeHandler = e => {
		this.setState({
			kitchen: e.target.value,
		});
	};
	PorchChangeHandler = e => {
		this.setState({
			Porch: e.target.value,
		});
	};

	search(arr) {
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].item === this.state.title) {
				return { find: true, index: i };
			}
		}
		return { find: false };
	}
	changeSizeHandler = (sizing, id, category) => {
		console.log(category);
		if (typeof sizing === 'object') {
			sizing = sizing.target.value;
		}
		console.log(sizing);
		const title = this.state.title;
		if (this.search(this.state[category].items).find) {
			this.setState(prevState => {
				let updatedDetails = [...prevState[category].items];
				updatedDetails[this.search(this.state[category].items).index] = { isSelected: true, item: title, quantity: this.state.selectedQuantity };
				return {
					...prevState,
					[category]: { ...prevState[category], items: updatedDetails },
				};
			});
		}
		for (let i in this.state.details[this.state.selectedCategory][title]) {
			if (this.state.details[this.state.selectedCategory][title][i].id === id) {
				this.setState(prevState => {
					let updatedDetails = [...prevState.details[this.state.selectedCategory][title]];
					updatedDetails[id] = { id: id, sizing: sizing };
					return {
						...prevState,
						details: { ...prevState.details, [prevState.selectedCategory]: { ...prevState.details[this.state.selectedCategory], [title]: updatedDetails } },
					};
				});
			}
		}
	};

	handleFinalSubmit = async () => {
		let data = this.props.location.state;
		let listOfItems = [];
		listOfItems.push(this.state.Dining_Room);
		listOfItems.push(this.state.Bed_Rooms);
		listOfItems.push(this.state.Living_Room);
		listOfItems.push(this.state.Kitchen);
		listOfItems.push(this.state.Miscellaneous);
		listOfItems.push(this.state.Nursery);
		listOfItems.push(this.state.Porch);
		listOfItems.push(this.state.Porch);
		listOfItems.push(this.state.Cartons);
		listOfItems.push(this.state.Appliances);

		data.listOfItems = listOfItems;

		// data = {"clientInfo":{"firstName":"Yamin","email":"yamin@gmail.com","phoneNo":"123456","lastName":"Yasin","prefferedMovingDate":"2020-06-23","prefferedMovingTime":"12:00"},"movingToDetails":{"street":"New Lahore","unitNumber":"3","city":"Lahore","state":"Punjab","zip":"2323","hasElevator":true,"flightOfStairs":"2"},"movingFromDetails":{"street":"seter @3","unitNumber":"34","city":"Peshaware","state":"KPK","zip":"1324","hasElevator":false,"flightOfStairs":"3"},"otherDetails":{"sizeOfCurrentHome":"1 Bedroom Apartment","packingServiceRequired":true,"storageRequired":false,"hearedAboutUs":"Google Search Ad"},"listOfItems":[{"categoryId":"5ef0b224e4f1515628bfdb40","items":[{"isSelected":true,"item":"Dining_Chair","quantity":2,"itemId":"5ef0b225e4f1515628bfdb41"},{"isSelected":false,"itemId":"","item":"Buffet","quantity":""},{"isSelected":false,"itemId":"","item":"Hutch","quantity":""},{"isSelected":false,"itemId":"","item":"Server","quantity":""},{"isSelected":false,"itemId":"","item":"Table","quantity":""},{"isSelected":false,"itemId":"","item":"Tea_Cart","quantity":""},{"isSelected":false,"itemId":"","item":"Rug","quantity":""}]},{"categoryId":"5ef0b245e4f1515628bfdb4c","items":[{"isSelected":true,"item":"Armoire","quantity":1,"itemId":"5ef0b23de4f1515628bfdb4b"},{"isSelected":true,"item":"Bed","quantity":2,"itemId":"5ef0b245e4f1515628bfdb4e"},{"isSelected":false,"item":"Chair","itemId":"","quantity":""},{"isSelected":false,"item":"Straight","itemId":"","quantity":""},{"isSelected":false,"item":"Chaise_Lounge","itemId":"","quantity":""},{"isSelected":false,"item":"Chest_Of_Drawers","itemId":"","quantity":""},{"isSelected":false,"item":"Dresser","itemId":"","quantity":""},{"isSelected":false,"item":"Rug","itemId":"","quantity":""},{"isSelected":false,"item":"Vanity","itemId":"","quantity":""}]},{"categoryId":"5ef0b209e4f1515628bfdb33","items":[{"isSelected":true,"item":"Bench","quantity":2,"itemId":"5ef0b200e4f1515628bfdb31"},{"isSelected":false,"itemId":"","item":"BookCase","quantity":""},{"isSelected":false,"itemId":"","item":"Book_Shelves","quantity":""},{"isSelected":false,"itemId":"","item":"Chair","quantity":""},{"isSelected":false,"itemId":"","item":"Desk","quantity":""},{"isSelected":true,"item":"Fireplace_Tools","quantity":4,"itemId":"5ef0b20ae4f1515628bfdb37"},{"isSelected":false,"itemId":"","item":"Foot_Stool","quantity":""},{"isSelected":false,"itemId":"","item":"Futon","quantity":""},{"isSelected":false,"itemId":"","item":"Lamp","quantity":""},{"isSelected":false,"itemId":"","item":"Music","quantity":""},{"isSelected":false,"itemId":"","item":"Piano","quantity":""},{"isSelected":false,"itemId":"","item":"Rug","quantity":""},{"isSelected":false,"itemId":"","item":"Stereo","quantity":""},{"isSelected":false,"itemId":"","item":"Table","quantity":""},{"isSelected":false,"itemId":"","item":"Telephone_Stand","quantity":""},{"isSelected":false,"itemId":"","item":"TV","quantity":""},{"isSelected":false,"itemId":"","item":"Tv_Stand","quantity":""}]},{"categoryId":"5ef0b22fe4f1515628bfdb43","items":[{"isSelected":false,"itemId":"","item":"Breakfast_Chair","quantity":""},{"isSelected":true,"item":"Breakfast_Table","quantity":4,"itemId":"5ef0b230e4f1515628bfdb47"},{"isSelected":false,"itemId":"","item":"Ironing_Board","quantity":""},{"isSelected":false,"itemId":"","item":"Kitchen_Cabinet","quantity":""},{"isSelected":false,"itemId":"","item":"Microwave_Stand","quantity":""},{"isSelected":false,"itemId":"","item":"Stool","quantity":""},{"isSelected":false,"itemId":"","item":"Dishwashers","quantity":""},{"isSelected":false,"itemId":"","item":"Utility_Cabinet","quantity":""},{"isSelected":false,"itemId":"","item":"Utility_Table","quantity":""}]},{"categoryId":"5ef0b211e4f1515628bfdb38","items":[{"isSelected":false,"itemId":"","item":"Bicycle","quantity":""},{"isSelected":false,"itemId":"","item":"Bird_Cage","quantity":""},{"isSelected":false,"itemId":"","item":"Cabinet_Filing","quantity":""},{"isSelected":false,"itemId":"","item":"Computer","quantity":""},{"isSelected":true,"item":"Fan","quantity":2,"itemId":"5ef0b211e4f1515628bfdb3a"},{"isSelected":false,"itemId":"","item":"Folding_Chair","quantity":""},{"isSelected":false,"itemId":"","item":"Foot_Locker","quantity":""},{"isSelected":false,"itemId":"","item":"Garbage_Can","quantity":""},{"isSelected":false,"itemId":"","item":"Golf_Bag","quantity":""},{"isSelected":false,"itemId":"","item":"Heater","quantity":""},{"isSelected":false,"itemId":"","item":"Office_Chair","quantity":""},{"isSelected":false,"itemId":"","item":"Ping_Pong_Tables","quantity":""},{"isSelected":false,"itemId":"","item":"Rollaway_Cot","quantity":""},{"isSelected":false,"itemId":"","item":"Skis","quantity":""},{"isSelected":false,"itemId":"","item":"Step_Ladder","quantity":""},{"isSelected":false,"itemId":"","item":"Tool","quantity":""},{"isSelected":false,"itemId":"","item":"Suitcase","quantity":""},{"isSelected":false,"itemId":"","item":"Tool_Chest","quantity":""},{"isSelected":false,"itemId":"","item":"Trunk","quantity":""},{"isSelected":false,"itemId":"","item":"Wagon","quantity":""},{"isSelected":false,"itemId":"","item":"Water_Cooler","quantity":""},{"isSelected":false,"itemId":"","item":"Weights","quantity":""},{"isSelected":false,"itemId":"","item":"Weight_Bench","quantity":""},{"isSelected":false,"itemId":"","item":"Wheel_Barrow","quantity":""},{"isSelected":false,"itemId":"","item":"Work_Bench","quantity":""}]},{"categoryId":"5ef0b24be4f1515628bfdb4f","items":[{"isSelected":false,"itemId":"","item":"Bassinet","quantity":""},{"isSelected":false,"itemId":"","item":"Bed","quantity":""},{"isSelected":false,"itemId":"","item":"Chair","quantity":""},{"isSelected":true,"item":"Chest","quantity":1,"itemId":"5ef0b24be4f1515628bfdb50"},{"isSelected":false,"itemId":"","item":"Crib","quantity":""},{"isSelected":false,"itemId":"","item":"PlayPen","quantity":""},{"isSelected":false,"itemId":"","item":"Rug","quantity":""},{"isSelected":false,"itemId":"","item":"Stroller","quantity":""},{"isSelected":false,"itemId":"","item":"Utility_Table","quantity":""}]},{"categoryId":"5ef0b21ce4f1515628bfdb3b","items":[{"isSelected":false,"itemId":"","item":"Tools","quantity":""},{"isSelected":false,"itemId":"","item":"Ladder","quantity":""},{"isSelected":false,"itemId":"","item":"Lawn_Chair","quantity":""},{"isSelected":true,"item":"Lawn_Mover","quantity":4,"itemId":"5ef0b21ce4f1515628bfdb3f"},{"isSelected":false,"itemId":"","item":"Outdoor_Childslide","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Dryingrack","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Swingset","quantity":""},{"isSelected":false,"itemId":"","item":"Picnic_Bench","quantity":""},{"isSelected":false,"itemId":"","item":"Picnic_Table","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_PortableBBQ","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Porchchair","quantity":""},{"isSelected":false,"itemId":"","item":"Rocker_Swing","quantity":""},{"isSelected":false,"itemId":"","item":"Sandbox","quantity":""},{"isSelected":false,"itemId":"","item":"Settee","quantity":""},{"isSelected":false,"itemId":"","item":"Umbrella","quantity":""}]},{"categoryId":"5ef0b21ce4f1515628bfdb3b","items":[{"isSelected":false,"itemId":"","item":"Tools","quantity":""},{"isSelected":false,"itemId":"","item":"Ladder","quantity":""},{"isSelected":false,"itemId":"","item":"Lawn_Chair","quantity":""},{"isSelected":true,"item":"Lawn_Mover","quantity":4,"itemId":"5ef0b21ce4f1515628bfdb3f"},{"isSelected":false,"itemId":"","item":"Outdoor_Childslide","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Dryingrack","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Swingset","quantity":""},{"isSelected":false,"itemId":"","item":"Picnic_Bench","quantity":""},{"isSelected":false,"itemId":"","item":"Picnic_Table","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_PortableBBQ","quantity":""},{"isSelected":false,"itemId":"","item":"Outdoor_Porchchair","quantity":""},{"isSelected":false,"itemId":"","item":"Rocker_Swing","quantity":""},{"isSelected":false,"itemId":"","item":"Sandbox","quantity":""},{"isSelected":false,"itemId":"","item":"Settee","quantity":""},{"isSelected":false,"itemId":"","item":"Umbrella","quantity":""}]},{"categoryId":"5ef0b236e4f1515628bfdb48","items":[{"isSelected":false,"itemId":"","item":"Box","quantity":""},{"isSelected":true,"item":"China_Barrel","quantity":1,"itemId":"5ef0b236e4f1515628bfdb49"},{"isSelected":false,"itemId":"","item":"Lamp_Shade","quantity":""},{"isSelected":false,"itemId":"","item":"Mirror","quantity":""},{"isSelected":false,"itemId":"","item":"Microwave_Stand","quantity":""},{"isSelected":false,"itemId":"","item":"Wardrobe","quantity":""}]},{"categoryId":"5ef0b253e4f1515628bfdb51","items":[{"isSelected":false,"itemId":"","item":"Air_Conditioner","quantity":""},{"isSelected":false,"itemId":"","item":"Dehumdifier","quantity":""},{"isSelected":false,"itemId":"","item":"Dishwasher","quantity":""},{"isSelected":false,"itemId":"","item":"Dryer","quantity":""},{"isSelected":true,"item":"Freezer","quantity":2,"itemId":"5ef0b253e4f1515628bfdb53"},{"isSelected":false,"itemId":"","item":"Microwave","quantity":""},{"isSelected":false,"itemId":"","item":"Foot_Stool","quantity":""},{"isSelected":false,"itemId":"","item":"Range","quantity":""},{"isSelected":false,"itemId":"","item":"Refrigerator","quantity":""},{"isSelected":false,"itemId":"","item":"Sewing_Machine","quantity":""},{"isSelected":false,"itemId":"","item":"Vaccum_Cleaner","quantity":""},{"isSelected":false,"itemId":"","item":"Washing_Machine","quantity":""}]}]}

		try {
			let postAllData = await axios.post('/itemsToMove', data);
			console.log(data);
			console.log(postAllData);
			if (postAllData.status === 201) {
				let client_id = postAllData.data.client._id;
				data.clientId = client_id;
				this.props.history.push({ pathname: '/finalcost', state: { ...this.props.location.state, data } });
			}
		} catch (err) {
			console.log(err);
		}
	};

	render() {
		const { classes } = this.props;
		let url = '';
		return (
			<Grid container xs={12} align='center'>
				<div className='section-title text-left mb--50 pl--100'>
					<h2 className='title'>Items Details</h2>
				</div>
				<Grid container xs={12} className={classes.FormContainer} style={{}} className={classes.MT}>
					<Grid container xs={12} sm={12} lg={12} justify='space-evenly'>
						<Grid item xs={12} sm={3} lg={3}>
							<form className={classes.PD}>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Living Room</InputLabel>
									<Select onChange={this.livingRoomChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Living_Room.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpen(items.item, items.sm, 'Living_Room');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog disableBackdropClick='true' open={this.state.openModel} onClose={this.handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{}} className={classes.DialogTitleHeading} onClose={this.handleClose}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle} style={{}}>
														Quantity of {this.state.title.replace(/_/g, ' ')}
													</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl required variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl style={{ marginTop: '2vh' }} required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								this.changeSizeHandler(size, i.id, 'Living_Room');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Living_Room')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>
						<Grid item xs={12} sm={3} lg={3}>
							<form className={classes.PD}>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Dining Room</InputLabel>
									<Select onChange={this.diningRoomChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Dining_Room.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenDining(items.item, items.sm, 'Dining_Room');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelDining} onClose={this.handleCloseDining} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseDining}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								this.changeSizeHandler(size, i.id, 'Dining_Room');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Dining_Room')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>

						<Grid item xs={12} sm={3} lg={3}>
							<form className={classes.PD}>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Bed Rooms</InputLabel>
									<Select onChange={this.bedRoomChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Bed_Rooms.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenBedroom(items.item, items.sm, 'Bed_Rooms');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelBedroom} onClose={this.handleCloseBedroom} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseBedroom}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								this.changeSizeHandler(size, i.id, 'Bed_Rooms');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Bed_Rooms')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>
					</Grid>
				</Grid>
				<Grid container xs={12} className={classes.MT}>
					<Grid container xs={12} sm={12} lg={12} justify='space-evenly'>
						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Miscellaneous</InputLabel>
									<Select onChange={this.miscChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Miscellaneous.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenMiscellaneous(items.item, items.sm, 'Miscellaneous');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelMiscellaneous} onClose={this.handleCloseMiscellaneous} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseMiscellaneous}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												{this.state.title === 'Gym_Equipment' ? (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Size of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Sizes[this.state.title].map(size => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={size}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, size);
																					}}>
																					{size}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
														</form>
													</div>
												) : (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Quantity.map(quantity => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={quantity.id}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, quantity.id);
																					}}>
																					{quantity.id}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
															<div>
																{this.state.Sizes[this.state.title]}
																{this.state.Sizes[this.state.title] !== undefined
																	? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<FormControl required variant='outlined' className={classes.formControl}>
																						<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																						<Select
																							style={{
																								width: 250,
																								textAlign: 'left',
																							}}
																							labelId='demo-simple-select-outlined-label'
																							id='demo-simple-select-outlined'
																							value={this.state.age}
																							label={this.state.item}>
																							{this.state.Sizes[this.state.title].map(size => (
																								<MenuItem
																									style={{ maxHeight: '80px' }}
																									value={size}
																									onClick={() => {
																										this.changeSizeHandler(size, i.id, 'Miscellaneous');
																									}}>
																									{size}
																								</MenuItem>
																							))}
																						</Select>
																					</FormControl>
																				</div>
																			);
																	  })
																	: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<TextField
																						required
																						style={{
																							textAlign: 'left',
																							width: 250,
																							paddingTop: '1vh',
																						}}
																						onChange={e => this.changeSizeHandler(e, i.id, 'Miscellaneous')}
																						id='outlined-basic'
																						label='Size'
																						variant='outlined'
																					/>
																				</div>
																			);
																	  })}
															</div>
															<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
																Submit
															</Button>
														</form>
													</div>
												)}
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>

						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Kitchen</InputLabel>
									<Select required onChange={this.kitchenChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Kitchen.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenKitchen(items.item, items.sm, 'Kitchen');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelKitchen} onClose={this.handleCloseKitchen} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseKitchen}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								this.changeSizeHandler(size, i.id, 'Kitchen');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Kitchen')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>

						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Nursery</InputLabel>
									<Select onChange={this.NurseryChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Nursery.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenNursery(items.item, items.sm, 'Nursery');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelNursery} onClose={this.handleCloseNursery} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseNursery}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												{this.state.title === 'Gym_Equipment' ? (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Size of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Sizes[this.state.title].map(size => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={size}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, size);
																					}}>
																					{size}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
														</form>
													</div>
												) : (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Quantity.map(quantity => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={quantity.id}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, quantity.id);
																					}}>
																					{quantity.id}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
															<div>
																{this.state.Sizes[this.state.title]}
																{this.state.Sizes[this.state.title] !== undefined
																	? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<FormControl required variant='outlined' className={classes.formControl}>
																						<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																						<Select
																							style={{
																								width: 250,
																								textAlign: 'left',
																							}}
																							labelId='demo-simple-select-outlined-label'
																							id='demo-simple-select-outlined'
																							value={this.state.age}
																							label={this.state.item}>
																							{this.state.Sizes[this.state.title].map(size => (
																								<MenuItem
																									style={{ maxHeight: '80px' }}
																									value={size}
																									onClick={() => {
																										this.changeSizeHandler(size, i.id, 'Nursery');
																									}}>
																									{size}
																								</MenuItem>
																							))}
																						</Select>
																					</FormControl>
																				</div>
																			);
																	  })
																	: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<TextField
																						required
																						style={{
																							textAlign: 'left',
																							width: 250,
																							paddingTop: '1vh',
																						}}
																						onChange={e => this.changeSizeHandler(e, i.id, 'Nursery')}
																						id='outlined-basic'
																						label='Size'
																						variant='outlined'
																					/>
																				</div>
																			);
																	  })}
															</div>
															<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
																Submit
															</Button>
														</form>
													</div>
												)}
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>
					</Grid>
				</Grid>
				<Grid container xs={12} className={classes.MT}>
					<Grid container xs={12} sm={12} lg={12} justify='space-evenly'>
						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Porch</InputLabel>
									<Select required onChange={this.NurseryChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Porch.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenPorch(items.item, items.sm, 'Porch');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelPorch} onClose={this.handleClosePorch} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleClosePorch}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								this.changeSizeHandler(size, i.id, 'Porch');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Porch')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>
						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Carton</InputLabel>
									<Select onChange={this.NurseryChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Cartons.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenCarton(items.item, items.sm, 'Cartons');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelCarton} onClose={this.handleCloseCarton} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseCarton}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												{this.state.title === 'Gym_Equipment' ? (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Size of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Sizes[this.state.title].map(size => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={size}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, size);
																					}}>
																					{size}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
														</form>
													</div>
												) : (
													<div>
														<form onSubmit={this.handleSubmit} className={classes.PD}>
															<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
															<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
															<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
																{this.state.shareholders.map((shareholder, idx) => (
																	<FormControl variant='outlined' className={classes.formControl}>
																		<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																		<Select
																			style={{
																				width: 250,
																				textAlign: 'left',
																			}}
																			labelId='demo-simple-select-outlined-label'
																			id='demo-simple-select-outlined'
																			value={this.state.age}
																			label={this.state.item}>
																			{this.state.Quantity.map(quantity => (
																				<MenuItem
																					style={{ maxHeight: '80px' }}
																					value={quantity.id}
																					onClick={() => {
																						this.handleChangeSelect(this.state.title, quantity.id);
																					}}>
																					{quantity.id}
																				</MenuItem>
																			))}
																		</Select>
																	</FormControl>
																))}
															</Grid>
															<div>
																{this.state.Sizes[this.state.title]}
																{this.state.Sizes[this.state.title] !== undefined
																	? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<FormControl required variant='outlined' className={classes.formControl}>
																						<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																						<Select
																							style={{
																								width: 250,
																								textAlign: 'left',
																							}}
																							labelId='demo-simple-select-outlined-label'
																							id='demo-simple-select-outlined'
																							value={this.state.age}
																							label={this.state.item}>
																							{this.state.Sizes[this.state.title].map(size => (
																								<MenuItem
																									style={{ maxHeight: '80px' }}
																									value={size}
																									onClick={() => {
																										this.changeSizeHandler(size, i.id, 'Cartons');
																									}}>
																									{size}
																								</MenuItem>
																							))}
																						</Select>
																					</FormControl>
																				</div>
																			);
																	  })
																	: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																			return (
																				<div key={i.id}>
																					<TextField
																						required
																						style={{
																							textAlign: 'left',
																							width: 250,
																							paddingTop: '1vh',
																						}}
																						onChange={e => this.changeSizeHandler(e, i.id, 'Cartons')}
																						id='outlined-basic'
																						label='Size'
																						variant='outlined'
																					/>
																				</div>
																			);
																	  })}
															</div>
															<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
																Submit
															</Button>
														</form>
													</div>
												)}
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
						</Grid>

						<Grid item xs={12} sm={3} lg={3}>
							<form>
								<FormControl required variant='outlined' className={classes.formControl} align='left' style={{ width: 250, background: 'white' }}>
									<InputLabel id='demo-simple-select-outlined-label'>Appliances</InputLabel>
									<Select required onChange={this.NurseryChangeHandler} labelId='demo-simple-select-outlined-label' id='demo-simple-select-outlined' label='Age'>
										{this.state.Appliances.items.map(items => (
											<MenuItem
												value={items.item.toString()}
												onClick={() => {
													this.handleOpenAppliance(items.item, items.sm, 'Appliances');
												}}>
												<div className={classes.DropDownList}>
													{items.item.replace(/_/g, ' ')} {items.isSelected ? <span className={classes.Cross}>X</span> : null}{' '}
												</div>
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<Dialog open={this.state.openModelAppliances} onClose={this.handleCloseCarton} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
									<DialogTitle id='alert-dialog-title' style={{ fontSize: '40px' }} onClose={this.handleCloseCarton}>
										{this.state.title.replace(/_/g, ' ')}
									</DialogTitle>
									<DialogContent className={classes.DialogContent}>
										<Grid container xs={12} align='center'>
											<Grid item xs={12}>
												<form onSubmit={this.handleSubmit} className={classes.PD}>
													<Typography className={classes.DialogSubTitle}>Quantity of {this.state.title.replace(/_/g, ' ')}</Typography>
													<Typography className={classes.DialogSubText}>{this.state.specificationMessagae}</Typography>
													<Grid item xs={12} align='center' style={{ paddingTop: '3vh' }}>
														{this.state.shareholders.map((shareholder, idx) => (
															<FormControl variant='outlined' className={classes.formControl}>
																<InputLabel id='demo-simple-select-outlined-label'>Quantity</InputLabel>
																<Select
																	style={{
																		width: 250,
																		textAlign: 'left',
																	}}
																	labelId='demo-simple-select-outlined-label'
																	id='demo-simple-select-outlined'
																	value={this.state.age}
																	label={this.state.item}>
																	{this.state.Quantity.map(quantity => (
																		<MenuItem
																			style={{ maxHeight: '80px' }}
																			value={quantity.id}
																			onClick={() => {
																				this.handleChangeSelect(this.state.title, quantity.id);
																			}}>
																			{quantity.id}
																		</MenuItem>
																	))}
																</Select>
															</FormControl>
														))}
													</Grid>
													<div>
														{this.state.Sizes[this.state.title] !== undefined
															? this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<FormControl required variant='outlined' className={classes.formControl}>
																				<InputLabel id='demo-simple-select-outlined-label'>Size</InputLabel>
																				<Select
																					style={{
																						width: 250,
																						textAlign: 'left',
																					}}
																					labelId='demo-simple-select-outlined-label'
																					id='demo-simple-select-outlined'
																					value={this.state.age}
																					label={this.state.item}>
																					{this.state.Sizes[this.state.title].map(size => (
																						<MenuItem
																							style={{ maxHeight: '80px' }}
																							value={size}
																							onClick={() => {
																								
																								this.changeSizeHandler(size, i.id, 'Appliances');
																							}}>
																							{size}
																						</MenuItem>
																					))}
																				</Select>
																			</FormControl>
																		</div>
																	);
															  })
															: this.state.details[this.state.selectedCategory][this.state.title].map(i => {
																	return (
																		<div key={i.id}>
																			<TextField
																				required
																				style={{
																					textAlign: 'left',
																					width: 250,
																					paddingTop: '1vh',
																				}}
																				onChange={e => this.changeSizeHandler(e, i.id, 'Appliances')}
																				id='outlined-basic'
																				label='Size'
																				variant='outlined'
																			/>
																		</div>
																	);
															  })}
													</div>
													<Button onClick={this.handleSubmit} style={{ background: 'green', color: 'white', width: '20vh', height: '45px', marginTop: '10vh' }}>
														Submit
													</Button>
												</form>
											</Grid>
										</Grid>
									</DialogContent>
								</Dialog>
							</form>
							<div className='header-btn align-left pt--50' style={{ width: '250px', textAlignLast: 'end' }}>
								<button className='rn-btn' onClick={this.handleFinalSubmit} style={{ height: '50px', width: '140px', paddingLeft: '40px', paddingTop: '5px' }}>
									<span style={{ fontSize: '17px' }}>Submit</span>
								</button>
							</div>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}
MoreInfoPage.propTypes = {
	className: PropTypes.string,
};
export default withRouter(withStyles(styles)(MoreInfoPage));
